import { render, staticRenderFns } from "./MoreInformationLoader.vue?vue&type=template&id=3f0a4c28"
import script from "./MoreInformationLoader.vue?vue&type=script&lang=js"
export * from "./MoreInformationLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports